import api from '../../../api/index';

export default {
  registerAffiliate({ rootGetters }, values) {
    return api.post('affiliate', values, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  get({ rootGetters, commit }, affiliateId) {
    return api
      .get(`admin/affiliate/${affiliateId}`, {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      })
      .then((response) => {
        commit('setAffiliate', response.data.data);
      });
  },
  getName({ rootGetters }, affiliateId) {
    return api.get(`affiliate/${affiliateId}/name`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getAll({ rootGetters, commit }) {
    return api
      .get('admin/affiliate/', {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      })
      .then((response) => {
        commit('setAffiliates', response.data.data);
      });
  },
  getUnvalued({ rootGetters, commit }) {
    return api
      .get('admin/affiliate/unvalued', {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      })
      .then((response) => {
        commit('setUnvaluedAffiliates', response.data.data);
      });
  },
  approve({ rootGetters }, affiliateId) {
    return api.put(`admin/affiliate/approve/${affiliateId}`, null, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  reject({ rootGetters }, data) {
    return api.put(`admin/affiliate/reject/${data.id}`, data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  indicateProfessional({ rootGetters }, data) {
    return api.post('affiliate/indicate/professional', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  registerShopkeeper({ rootGetters }, data) {
    return api.post('/affiliate/shopkeeper', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  report({ rootGetters }, filters) {
    return api.post('affiliate/report', filters, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getReportShopkeepers({ rootGetters }, filters) {
    return api.post('affiliate/report/shopkeepers', filters, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  updateTelephones({ rootGetters }, filters) {
    return api.put('affiliate/telephone', filters, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  updateAddress({ rootGetters }, addressData) {
    return api.put('affiliate/address', addressData, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getDashboardData({ rootGetters }, data) {
    return api.post('affiliate/dashboard', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
};
